import React from 'react';

function ErrorBoundaryFallbackRenderer({ error, resetErrorBoundary }) {
  return (
    <>
      <span>Something went wrong with application.</span>
      <br />
      <span>
        If the restore proves to be successful, it is recommended to{' '}
        <b>Save CF</b> immediately.
      </span>
      <br />
      <button onClick={resetErrorBoundary}>
        Attempt to return to previous state
      </button>
    </>
  );
}

export default ErrorBoundaryFallbackRenderer;
